var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77299 8.5497C9.77299 9.32786 9.29127 9.9578 8.36489 9.9578C7.51262 9.9578 6.95679 9.32786 6.95679 8.62381C6.95679 7.84565 7.51262 7.1416 8.36489 7.1416C9.21716 7.1416 9.77299 7.77154 9.77299 8.5497Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77299 10.6621H6.95679V19.8148H9.77299V10.6621Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.517 10.8105C15.0348 10.8105 14.1826 11.6628 13.8491 12.2186H13.7749L13.6267 11.0329H11.107C11.107 11.811 11.1811 12.7374 11.1811 13.775V19.815H13.9973V14.8125C13.9973 14.5161 13.9973 14.3308 14.0714 14.1085C14.2937 13.6267 14.6272 12.9968 15.4054 12.9968C16.4059 12.9968 16.8135 13.8491 16.8135 14.9607V19.815H19.6297V14.6272C19.6297 11.9963 18.2957 10.8105 16.517 10.8105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedIn);
export default __webpack_public_path__ + "static/media/logoLinkedIn.ad3fca47af601221ed4448964972360f.svg";
export { ForwardRef as ReactComponent };